<form [formGroup]="form" class="p-4 font-display sm:p-6">
  <div class="flex flex-wrap items-center justify-between gap-4 w-full mb-4">
    <div class="flex items-center gap-4">
      <div
        class="h-10 w-10 border border-[#767676] text-[#1E1E1E] rounded-lg flex items-center justify-center"
      >
        <i class="fa-solid fa-file-excel text-lg"></i>
      </div>
      <h2 class="text-lg font-semibold text-[#1E1E1E] sm:text-xl">
        Generate Excel
      </h2>
    </div>
    <button (click)="closeDialog()"><i class="fa-solid fa-xmark"></i></button>
  </div>
  <h2 class="text-base font-semibold text-[#1E1E1E] sm:text-lg">
    Exporting the data into excel
  </h2>
  <p class="text-[#767676] mb-4 text-sm">
    Please confirm the export and select the desired Excel format for your data.
  </p>

  <mat-radio-group
    formControlName="options"
    class="flex flex-col space-y-4 mt-6"
  >
    <div class="flex items-start gap-2">
      <mat-radio-button value="1"></mat-radio-button>
      <div class="w-full flex flex-col space-y-4">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div class="flex flex-col space-y-1 text-sm">
            <span class="font-semibold"
              >Select the currently displayed data</span
            >
            <span class="text-[#767676]"
              >The data displayed in the table will be exported to Excel</span
            >
          </div>
          <mat-select
            formControlName="type"
            class="!w-full sm:!w-40 h-10 p-2 !text-sm rounded-lg border border-gray-200 !font-display"
            placeholder="Pilih jenis laporan"
          >
            <mat-option
              value="all"
              class="!font-display !text-sm text-[#3B3B3B]"
              >Print All The Page</mat-option
            >
          </mat-select>
        </div>
        <mat-divider class="!border-dashed"></mat-divider>
      </div>
    </div>
    <div class="flex items-start space-x-2">
      <mat-radio-button value="2"></mat-radio-button>
      <div class="w-full flex flex-col space-y-4">
        <div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
          <div class="flex flex-col space-y-1 text-sm">
            <span class="font-semibold">Date Range</span>
            <span class="text-[#767676]"
              >Select a date range to print the data displayed in the
              table.</span
            >
          </div>
        </div>
        <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
          <div class="flex flex-col space-y-1">
            <span class="font-semibold text-sm">Start Date</span>
            <input
              formControlName="startDate"
              [attr.max]="form.get('endDate')?.value || null"
              [readonly]="this.form.get('options')?.value != 2"
              [ngClass]="
                this.form.get('options')?.value != 2 ? 'bg-gray-200' : ''
              "
              type="date"
              class="border border-gray-300 rounded-lg p-3 h-10 w-full sm:w-40 text-sm"
             placeholder="Pilih tanggal mulai"/>
          </div>
          <span class="font-semibold text-xl hidden sm:inline">-</span>
          <div class="flex flex-col space-y-1">
            <span class="font-semibold text-sm">End Date</span>
            <input
              formControlName="endDate"
              [attr.min]="form.get('startDate')?.value || null"
              [readonly]="this.form.get('options')?.value != 2"
              [ngClass]="
                this.form.get('options')?.value != 2 ? 'bg-gray-200' : ''
              "
              type="date"
              class="border border-gray-300 rounded-lg p-3 h-10 w-full sm:w-40 text-sm"
             placeholder="Pilih tanggal selesai"/>
          </div>
        </div>
        <mat-divider class="!border-dashed"></mat-divider>
      </div>
    </div>
    <div class="flex items-start gap-2">
      <mat-radio-button value="3"></mat-radio-button>
      <div class="w-full flex flex-col space-y-4">
        <div class="flex items-start justify-between">
          <div class="flex flex-col space-y-1 text-sm">
            <span class="font-semibold">Export All</span>
            <span class="text-[#767676]"
              >Export all available data to Excel. Please notethat this process
              may take longer depending on the data size.</span
            >
          </div>
        </div>
        <mat-divider class="!border-dashed"></mat-divider>
      </div>
    </div>
  </mat-radio-group>

  <div class="flex w-full flex-col justify-end items-stretch gap-2 mt-6 sm:flex-row sm:items-center">
    <button
      (click)="generate()"
      class="bg-[#85E2B1] text-white py-2 px-6 rounded-lg focus:outline-none"
    >
      Generate
    </button>
    <button
      (click)="closeDialog()"
      class="bg-[#8C8C8C] text-white py-2 px-6 rounded-lg focus:outline-none"
    >
      Cancel
    </button>
  </div>
</form>
